import { Injectable } from '@angular/core';
import { StripeApiService } from './api/stripe-api.service';

@Injectable({
    providedIn: 'root',
})
export class StripeService {
    constructor(private stripeApiService: StripeApiService) {}

    public getStripePublishableKey() {
        return this.stripeApiService.getStripePublishableKey();
    }

    public createSetupIntent() {
        return this.stripeApiService.createSetupIntent();
    }
}
